<div class="background-container">
  <div class="background-body">
    <div class="wrapper">
      <img class="south-stamp" *ngIf="showStamp" src="/assets/image/south-africa-stamp.png" />

      <img class="bon-voyage" src="/assets/image/bon-voyage-stamp.png" />

      <img class="stamps-and-logo" src="/assets/image/Stamps_and_logo.png" />

      <div class="content-wrapper">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
</div>
